import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import LodgingDoorExportModal from 'components/Modals/ExportModal/LodgingDoorExportModal'
import { getLodgingDoorList, getLodgingDoorSummary } from 'services/places'
import {
  GOOGLE_PLACE_DOORS_DEFAULT_COLUMN_VISIBILITY,
  GOOGLE_PLACE_DOORS_INITIAL_COLUMN_ORDER,
  GOOGLE_PLACE_DOORS_PROXY_ACCESSORS,
  GOOGLE_PLACE_DOORS_SORTABLE_FIELDS,
} from '../../GooglePlaceBase/googlePlaceDoorsTargetTable'
import { LodgingDoorsFilterset } from './LodgingDoorsFilterset'
import { useLodgingDoorsTableCols } from './LodgingDoorsTableColumns'

export const lodgingDoorsTableConfig = defineTargetTableConfig({
  // Lodging door columns nest under `lodging` (GooglePlaceBaseDoorTableColumns
  // accesor="lodging", detail link `/lodging/door/<lodging.id>`).
  vertical: 'lodging',
  rowConfig: { accessor: 'lodging' },
  filterIdentifier: 'LODGING_DOOR_TABLE',
  savedPresetsIdentifier: 'LODGING_DOOR_TABLE',
  companyTypeSlug: 'lodging-hospitality',
  tableTypeSlug: 'lodging-hospitality-doors',
  sortableFields: GOOGLE_PLACE_DOORS_SORTABLE_FIELDS,
  preferredGroupOrder: [
    'Target Attributes',
    'Hotel Amenities',
    'Campaigns and Deals',
  ],
  searchPlaceholder: 'Search lodging by name',
  ...GOOGLE_PLACE_DOORS_PROXY_ACCESSORS,
  // Lodging doors reads the active campaign id off `campaigns` (the other
  // tables use `main_campaign`).
  inCampaignsKey: 'campaigns',
  initialColumnOrder: GOOGLE_PLACE_DOORS_INITIAL_COLUMN_ORDER,
  defaultColumnVisibility: GOOGLE_PLACE_DOORS_DEFAULT_COLUMN_VISIBILITY,
  useColumns: useLodgingDoorsTableCols,
  Filterset: LodgingDoorsFilterset,
  ExportModal: LodgingDoorExportModal,
  // dev moved the lodging-door fetchers off the `api` service hook
  // (`api.getLodgingDoorList`) to standalone exports in `services/places`.
  resolveLegacyActions: () => ({
    listAction: getLodgingDoorList,
    summaryAction: getLodgingDoorSummary,
  }),
})

// Lodging doors is the one doors table that exposes `AfterSearchComponent`, so
// it takes the full TargetTableProps.
export function LodgingDoorTable(props: TargetTableProps) {
  return <TargetTable config={lodgingDoorsTableConfig} {...props} />
}
